import {TypeName, Traceable} from "./interfaces";
import {AbstractBaseEntity} from "./abstract-base-entity";

export class BaseGroup extends AbstractBaseEntity implements Traceable, TypeName{
  roles: string[];
  name: string;
  active: boolean;

  public override updateFromQuery(_instance: unknown): void {
    const entity = _instance as any;

    this.id = entity.id
    this.name = entity.name
    this.active = entity.active
    this.roles = entity.roles
  }
}
